import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
// import { useInactivityChecker } from '../../hooks/useInactivityChecker';
// import useAuthContext from '../../hooks/useAuthContext';
//import Banner from '../Notification/Banner';

function Container({ children }) {
  // const { logout } = useAuthContext();

  useEffect(() => {
    const rememberSession = JSON.parse(localStorage.getItem('RememberSessionPS'));
    if (!rememberSession) {
      // el cliente solicito que nunca se deslogueara el usuario, dejo comentada la implementacion, por si cambia de parecer
      // const sessionTimeout = useInactivityChecker(4*60*60*1000); // tiempo de expiracion de token definido para 4h
      // sessionTimeout && logout();
    }
  }, []);

  return (
    <div className="bg-white">
      <main>
        <div className="">{children}</div>
      </main>
    </div>
  );
}

Container.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(Container);
